module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "ballot",
    attrs: {
      "justify-center": ""
    }
  }, [(_vm.pres) ? _c('v-layout', {
    staticClass: "president",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('plaque', {
    attrs: {
      "president": ""
    }
  }), _c('span', {
    staticClass: "title name"
  }, [_vm._v(_vm._s(_vm.pres.name))])], 1) : _vm._e(), (_vm.chan) ? _c('v-layout', {
    staticClass: "chancellor",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('plaque', {
    attrs: {
      "chancellor": ""
    }
  }), _c('span', {
    staticClass: "title name"
  }, [_vm._v(_vm._s(_vm.chan.name))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6dd8e18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.common/ui/government/index.vue
// module id = 357
// module chunks = 0